<script setup lang="ts">
import ReferenceDatatable from '@/components/references/ReferenceDatatable.vue'
import { computed, useTemplateRef } from 'vue'
import { useI18n } from 'vue-i18n'

defineOptions({
  name: 'SalaryDatatable'
})

const { t } = useI18n()
const datatable =
  useTemplateRef<InstanceType<typeof ReferenceDatatable>>('datatable')

const headers = computed(() => ({
  title: { title: `${t('general.number')} - ${t('salary.recipient')}` },
  date: { title: t('salary.labels.payment_date') }
}))

defineExpose({
  refresh: () => datatable.value?.refresh()
})
</script>

<template>
  <ReferenceDatatable
    ref="datatable"
    endpoint="payslips?orderby=id&desc=true"
    :headers
  />
</template>
